import { Grid, Icon, Typography }        from "@gupshup-frontend/gupshup-ts-components";

import { TEMPLATE_PREVIEW_DATA_TESTID }  from "./constant";
import styles                            from "./style.module.css";

const Passkey = () => {

  return (
    <Grid className = {styles.passkeyPanel}>
      <Grid className = {styles.passkeyIconWrapper}>
        <Icon
          size   = {16}
          name   = "user"
          weight = "fill"
          alt    = "Passkey Icon"
          color  = "var(--palette-common-black)"
        />
      </Grid>
      <Grid container flexDirection = "column" gap = {0.5}>
        <Typography variant = "caption" fontWeight = {500} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.PASSKEY_HEADER}>
            Verify it's you with a passkey
          </Typography>
        <Typography className = {styles.passkeySubheader} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.PASSKEY_DESCRIPTION}>
          Use a passkey for a secure, easy way to verify with businesses.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Passkey;
